export enum ButtonData_Type {
  /** LINK - Regular link button */
  LINK = "LINK",
  /** ACTION - Triggers custom action that is defined in plugin configuration by the consumer */
  ACTION = "ACTION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Background type */
export enum ButtonData_Styles_Background_Type {
  /** COLOR - Solid color background */
  COLOR = "COLOR",
  /** GRADIENT - Gradient background */
  GRADIENT = "GRADIENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}